<template>
  <v-navigation-drawer
    v-model="Sidebar_drawer"
    :dark="SidebarColor !== 'white'"
    :color="SidebarColor"
    mobile-break-point="960"
    clipped
    :right="$vuetify.rtl"
    mini-variant-width="70"
    :expand-on-hover="expandOnHover"
    app
    id="main-sidebar"
    v-bar
  >
    <!---USer Area -->
    <v-list-item two-line class="black">
      <v-list-item-content class="white--text">
        <v-list-item-title v-if='$root.user !== null'>{{$root.user.email}}</v-list-item-title>
        <!-- <v-list-item-subtitle class="caption white--text">{{$root.members[0].LGA}}</v-list-item-subtitle> -->
      </v-list-item-content>
    </v-list-item>
    <!---USer Area -->

    <v-list expand nav class="mt-1">
      <template v-for="(item, i) in items">
        <!---If Sidebar Caption -->
        <v-row v-if="item.header" :key="item.header" align="center">
          <v-col cols="12">
            <v-subheader v-if="item.header" class="d-block text-truncate">{{ item.header }}</v-subheader>
          </v-col>
        </v-row>
        <!---If Sidebar Caption -->
        <BaseItemGroup v-else-if="item.children" :key="`group-${i}`" :item="item"></BaseItemGroup>
        <BaseItem v-else :key="`item-${i}`" :item="item" />
      </template>
      <!---Sidebar Items -->
    </v-list>
    <v-divider></v-divider>
    
  </v-navigation-drawer>
</template>

<script>
import { mapState } from "vuex";
export default {
  name: "Sidebar",
  props: {
    expandOnHover: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    showBars:false,
    items: [
      {
    }
    ]
  }),
  mounted() {
    if(this.$root.isLga){
        this.items.push({
        title: "Dashboard",
        icon: "mdi-gauge",
        to: "/dashboard"
    })
    this.items.push({
        title: "Submission",
        icon: "mdi-plus-thick",
        to: "/submission"
    })
        this.items.push({
        title: "Quicklinks",
        icon: "mdi-cursor-default",
        to: "/quicklinks"
    })
    }else{
      this.items.push({
        title: "Dashboard",
        icon: "mdi-gauge",
        to: "/dashboard"
      })
    this.items.push({
        title: "Users",
        icon: "mdi-account",
        to: "/users"
    })
    this.items.push({
        title: "Programs",
        icon: "mdi-briefcase-check-outline",
        to: "/programs"
    })
    this.items.push({
        title: "Submission",
        icon: "mdi-plus-thick",
        to: "/submission"
    })
        this.items.push({
        title: "Quicklinks",
        icon: "mdi-cursor-default",
        to: "/quicklinks"
    })
    this.items.push({
        title: "On Demand (beta)",
        icon: "mdi-arrow-right-drop-circle",
        to: "/ondemand"
    })
    //   this.items.push(
    //   {
    //     title: 'Edit Programs',
    //     icon: 'mdi-table-column-width',
    //     to: '/tables/tabledatatable/',
    // },
    // )
    }
  },
  computed: {
    ...mapState(["SidebarColor", "SidebarBg"]),
    Sidebar_drawer: {
      get() {
        return this.$store.state.Sidebar_drawer;
      },
      set(val) {
        this.$store.commit("SET_SIDEBAR_DRAWER", val);
      }
    }
  },
  watch: {
    "$vuetify.breakpoint.smAndDown"(val) {
      this.$emit("update:expandOnHover", !val);
    }
  },

  methods: {}
};
</script>
<style lang="scss">
#main-sidebar > div.v-navigation-drawer__content.vb-content > div.v-list.mt-1.v-sheet.theme--light.v-list--nav > a:nth-child(1){
  display:none;
}
#main-sidebar{
  box-shadow:1px 0 20px rgba(0,0,0,.08);
  -webkit-box-shadow:1px 0 20px rgba(0,0,0,.08);
  .v-navigation-drawer__border{
    display: none;
  }
  .v-list {
    padding: 8px 15px;
  }
  .v-list-item{
      &__icon--text,
      &__icon:first-child{
        justify-content: center;
        text-align: center;
        width: 20px;
        
      }
  }
  .profile-bg{
    background:url('../../../assets/images/user-info.jpg') no-repeat;
    .v-avatar{
      padding:45px 0;
    }
  }
  

}
</style>